import { Link } from 'react-router-dom';
import { popularAnime } from '@/mocks/anime';

export default function RankingSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
            热门排行榜
          </h2>
          <p className="text-sm text-foreground-500">最受观众喜爱的动漫作品</p>
        </div>
        <div className="space-y-2">
          {popularAnime.slice(0, 5).map((anime, index) => (
            <Link
              key={anime.id}
              to={`/anime/${anime.id}`}
              className="flex items-center gap-4 p-3 md:p-4 bg-white rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-accent-500 text-white font-heading text-sm shrink-0">
                {index + 1}
              </div>
              <div className="w-12 h-16 md:w-14 md:h-20 rounded overflow-hidden shrink-0">
                <img
                  src={anime.coverImage}
                  alt={`${anime.title} - 羞羞动漫热门推荐`}
                  title={`${anime.title} | 热门排行榜`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate mb-1">
                  {anime.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500 flex-wrap">
                  <span className="whitespace-nowrap">{anime.category}</span>
                  <span className="whitespace-nowrap">{anime.episodes}</span>
                  <span className="whitespace-nowrap text-accent-500 font-medium">{anime.rating} 分</span>
                </div>
              </div>
              <div className="text-right shrink-0">
                <div className="text-sm font-medium text-primary-500 whitespace-nowrap">
                  {(anime.views / 10000).toFixed(0)} 万
                </div>
                <div className="text-xs text-foreground-400 whitespace-nowrap">次观看</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}